<template>
    <section style="height: 100%;">
        <div class="flex align-center" style="padding: 15px 0;">
            <img :src="bs" alt=""/>
            <span style="color:#FFFFFF;font-size: 18px;font-weight: bold;margin-left: 10px">出租状况</span>
        </div>
        <div style="height: 75%;border: 1px #2BA3FF dashed">
            <div id="hireECharts" style="height: 100%;width: 99%;"></div>
        </div>
    </section>
</template>

<script>
import * as echarts from "echarts";

const bs = require("@images/icon/bs.png");
import {getRentBar} from '@/api/data-screen';

export default {
    name: "hire-situation",
    data() {
        return {
            bs,
            ECharts: null,
            options: {
                grid: {x: 40, y: 30, x2: 30, y2: 30},
                legend: {},
                tooltip: {trigger: 'axis', axisPointer: {type: 'shadow'}},
                xAxis: {
                    type: 'category',
                    axisLabel: {textStyle: {fontSize: 10, color: '#33A6FF',},},
                },
                yAxis: {
                    type: 'value',
                    splitLine: {show: true, lineStyle: {type: 'dashed', color: '#2F5594'}},
                    axisLabel: {textStyle: {fontSize: 10, color: '#33A6FF',},},
                },
                series: [
                    {
                        type: 'bar',
                        barWidth: 8,
                        itemStyle: {
                            color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#308AFF'
                            }, {offset: 1, color: '#FFFFFF'}]),
                            borderRadius: [2, 2, 0, 0],
                        },
                        tooltip: {
                            valueFormatter(value) {
                                return '已出租 ' + value + ' 套';
                            }
                        },
                    }
                ],
            }
        };
    },
    components: {},
    methods: {
        eChartsInit(eChartsName, eChartsOptions) {
            let {...options} = eChartsOptions;
            this[eChartsName] = echarts.init(document.getElementById(eChartsName));
            this[eChartsName].setOption(options, true);
            window.addEventListener("resize", () => {
                this[eChartsName].resize();
            });
        },
        formatOption(eChartsOptions, xData, data1) {
            eChartsOptions.xAxis.data = xData;
            eChartsOptions.series[0].data = data1;
            return eChartsOptions;
        },
        getRentBar() {
            const that = this;
            const {options} = that;
            getRentBar().then(res => {
                const {info: {month, data1}} = res;
                const eChartsOptions = that.formatOption(options, month, data1);
                that.eChartsInit("hireECharts", eChartsOptions);
            });
        }
    },
    mounted() {
        this.getRentBar();

    }
}
</script>

<style scoped>

</style>